import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { Agents } from 'views/agents'

const AgentsPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'agents.meta.title' })}
        description={formatMessage({ id: 'agents.meta.description' })}
      />
      <Header bordered={false} />
      <Agents />
      <Footer />
    </>
  )
}

export default AgentsPage
